
<template>
  <div>
    <button v-on:click="startRecord" v-show="isShow">开始对讲</button>
    <button v-on:click="stopRecord" v-show="!isShow">停止对讲</button>
    <div style="height: 20px;"></div>
    <div style="height: 20px;" v-show="!isShow">正在通话中</div>
  </div>
</template>


<script>

//<meta http-equiv="Content-Security-Policy" content="upgrade-insecure-requests"/>

import { reSampleAndEncodeAudioData } from './encode'
import axios from 'axios'
//import { request} from "../../config/request"

//统一配置
//let webapi = 'http://localhost:11135'

//let webapi = 'http://localhost:8001'

//let webapi = 'https://emergency.3-map.cn:8443'

let webapi = 'https://emergency.3-map.cn'

let audioSendAddrForHttp = 'url'

export default {
  name: "Microphone",
  data() {
    return {
      audioContext: null,
      processorNode: null,
      audioSourceNode: null,
      mediaStream: null,
      dataList: [],
      isShow: true
    }
  },
  metaInfo: {
    meta: [
      { name: "http-equiv", content: "Content-Security-Policy" },
      { name: "content", content: "upgrade-insecure-requests" },
    ]
  },
  computed: {
    ratio: function () {
      // 不太可能出现这种情况，常见的音频设备采样率是 48k 44.1k
      if (!this.audioContext || this.audioContext.sampleRate < 8000) {
        return 1
      }
      return Math.floor(this.audioContext.sampleRate / 8000)
    }
  },
  mounted() {
    this.audioContext = new AudioContext()
  },
  methods: {
    getMediaStream() {
      // 大部分浏览器有安全限制，http 协议访问的页面 navigator.mediaDevices 也是 undefined， 仅提供 https 服务的可以忽略这个问题
      if (!navigator.mediaDevices) {
        return Promise.reject('您的浏览器不支持获取用户设备，无法使用对讲功能，建议使用 Chrome 浏览器 ( 版本 >= 74 )')
      }
      return navigator.mediaDevices.getUserMedia({ audio: true })
        .catch(() => Promise.reject('请确保录音设备正常，并允许浏览器获取录音权限，否则无法使用对讲功能'))
    },

    async makeAudioContextRunning() {
      // 一般不会出现这种情况，以防万一
      if (!this.audioContext || this.audioContext.state === 'closed') {
        this.audioContext = new AudioContext()
      }
      if (this.audioContext.state === 'suspended') {
        await this.audioContext.resume()
      }
    },

    async startRecord() {

      //接收elevatorId，用于获取电梯配置的摄像头云端信息，?1627&sound
      let elevatorId = "";
      let model = "";
      var elul = location.search;
      if (elul.indexOf("?") != -1) {
        var strns = elul.replace("?", "").split("&");
        elevatorId = strns[0];
        model = strns[1];

        //elevatorId = str;
      }

      this.isShow = false;

      //console.log(elevatorId);
      //console.log($(webapi));

      //发起语音对讲，调用后端方法链接七牛云
      const postUrl = webapi + '/api/Talk/TalkStart';
      console.log(postUrl)
      axios.post(postUrl, { 'base64_pcm': "start", "elevatorId": elevatorId, "model": model }, {
        headers: { "Content-Type": "application/json;charset=utf-8" },
        changeOrigin: true
      })
        .then(response => {
          //this.message = response
          //console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx")
          //console.log(response.data)
          //console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx")
          audioSendAddrForHttp = response.data
          console.log("--------------------start-" + model + "-SendMute--------------------")



        })
        .catch(error => {
          console.log("startError:" + error)
        })



      this.mediaStream = await this.getMediaStream()

      await this.makeAudioContextRunning()
      try {
        this.audioSourceNode = this.audioContext.createMediaStreamSource(this.mediaStream)
        // 只采集单声道方便处理数据
        this.processorNode = this.audioContext.createScriptProcessor(4096, 1, 1)
        this.audioSourceNode.connect(this.processorNode)
        // sampleRate = 8k & bufferSize = 4096 => 每 0.512s 触发一次 onaudioprocess
        this.processorNode.onaudioprocess = this.onAudioProcess
        this.processorNode.connect(this.audioContext.destination)
      } catch (e) {
        throw new Error('您的浏览器音频相关接口异常，无法使用对讲功能，建议使用 Chrome 浏览器 ( 版本 >= 74 )')
      }

      if (model == "sound") {
        window.location.href = "SendMute://hello"
      }
    },

    onAudioProcess(event) {
      const channelData = event.inputBuffer.getChannelData(0)
      this.dataList.push(channelData.slice())

      // 每 (bufferSize * ratio / audioContext.sampleRate ～ bufferSize / audioSampleRate = 4096 / 8k = 0.512s) 发送一次数据
      if (this.dataList.length >= this.ratio) {
        this.sendAudioData(this.dataList)
        this.dataList = []
      }
    },

    sendAudioData(dataList) {
      const base64Audio = reSampleAndEncodeAudioData(dataList, 4096, this.ratio)
      // TODO post data

      //发起语音对讲，调用后端方法链接七牛云
      const postUrl = audioSendAddrForHttp
      if (audioSendAddrForHttp != 'url') {
        axios.post(postUrl, { 'base64_pcm': base64Audio }, {
          headers: { "Content-Type": "application/json" },
          changeOrigin: true
        })
          .then(response => {
            this.message = response
            //console.log(response)
          })
          .catch(error => {
            console.log("audioUrl:" + postUrl)
            console.log("audioUrlError:" + error)
          })

        //console.log("************************************************************")
        //console.log("base64Audio:" + base64Audio)
        //console.log("************************************************************")
      }
    },

    stopRecord() {
      if (this.dataList.length) {
        this.sendAudioData(this.dataList)
        this.dataList = []
      }
      this.releaseResources()


      //接收elevatorId，用于获取电梯配置的摄像头云端信息
      let elevatorId = "";
      let model = "";
      var elul = location.search;
      if (elul.indexOf("?") != -1) {
        //var str = elul.replace("?","");
        //elevatorId = str;

        var strns = elul.replace("?", "").split("&");
        elevatorId = strns[0];
        model = strns[1];
      }

      this.isShow = true;

      //发起语音对讲，调用后端方法链接七牛云
      const postUrl = webapi + '/api/Talk/TalkStop';
      console.log(postUrl)

      //发起语音对讲，调用后端方法链接七牛云 
      //const postUrl = 'https://emergency.3-map.cn:8443/api/Talk/TalkStop';
      axios.post(postUrl, { 'base64_pcm': "stop", "elevatorId": elevatorId, "model": model }, {
        headers: { "Content-Type": "application/json;charset=utf-8" },
        changeOrigin: true
      })
        .then(response => {
          this.message = response
          console.log("stopResponse:" + response)
          audioSendAddrForHttp = 'url'

          console.log("--------------------stop-" + model + "-SendMute--------------------")

        })
        .catch(error => {
          console.log("stopError" + error)
        })

      if (model == "sound") {
        window.location.href = "SendMute://hello"
      }
    },

    releaseResources() {
      if (this.audioSourceNode) {
        this.audioSourceNode.disconnect()
      }
      if (this.processorNode) {
        this.processorNode.disconnect()
      }
      if (this.mediaStream) {
        this.mediaStream.getAudioTracks().forEach(track => track.stop())
      }
    }
  },

  beforeDestroy() {
    this.releaseResources()
    this.audioContext.close()
  }
}
</script>

<style scoped>
</style>
